const vip = {
  title: 'VIP',
  subTitle1: 'What is VIP',
  subTitle2: 'VIP experience',
  subTitle3: 'VIP validity period',
  subTitle4: 'VIP Upgrade',
  subTitle5: 'VIP level protection',
  subTitle6: 'VIP downgrade',
  subTitle7: 'VIP Experience points',
  content1:
    'VIP is a special identity within the app. Becoming a VIP can unlock multiple privileges within the app. The high VIP the more privileges you can get.',
  content2:
    'You can gain VIP experience point by recharging coins in the app (1 coin = 1 VIP experience). VIP experience can be used to upgrade and keep your VIP level. If you request a refund, all VIP experience you gained through recharging will be deducted.',
  content3: 'Each VIP level is valid for 60 days, starting from the day you obtain VIP.',
  content4:
    'If your VIP experience reaches the requirements for a higher level upgrade during the VIP validity period, your VIP level will be upgraded immediately, your VIP experience will be reset to zero, and the VIP days will be recalculated.',
  content5:
    'If your VIP experience reaches the level protection requirements within the VIP validity period, your VIP will be automatically renewed after expiration.',
  content6:
    'If your VIP experience is not enough for level protection and upgrade, VIP will be downgraded to the corresponding level.',
  table: {
    level: 'Level',
    totalRechargeCoins: 'Total Recharge coins',
    upgradeVipExp: 'Required VIP Exp',
    maintainVipExp: 'Maintain VIP Exp',
  },
};

export default {
  vip,
};
